/**
 * Lightweight analytics helper — wraps gtag for funnel tracking.
 * Usage: track("cta_click", { page: "homepage", button: "start_audit" })
 */
export function track(event, params = {}) {
  try {
    if (window.gtag) {
      window.gtag("event", event, params);
    }
  } catch {
    // silent — never break the app for analytics
  }
}
